import { forwardRef, useImperativeHandle, useRef } from 'react';

import SendIcon from '#/assets/svgs/SendIcon.svg';

const MessageInput = forwardRef(function MessageInput(
  { inputField, isSending, handleChange, handleEnterKeyPress, submitForm, placeholder = 'Write a message...' },
  ref
) {
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    },
  }));

  return (
    <div className="message-field">
      <input
        //TODO: We might be need this code later when we need to focus the input field
        // ref={inputRef}
        name="inputField"
        type="text"
        placeholder={placeholder}
        value={inputField}
        onChange={handleChange}
        onKeyDown={handleEnterKeyPress}
        disabled={isSending}
      />
      <button
        className={!!inputField.trim() && !isSending ? 'active' : ''}
        onClick={submitForm}
        disabled={!inputField.trim() || isSending}
      >
        <SendIcon />
      </button>
    </div>
  );
});

export default MessageInput;
